var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Chip, PiggyBankIcon } from '@honeycomb/ui-core';
import { useGlobalContext, useModal } from '@honeycomb/data';
export function HotelPayMonthlyPill(_a) {
    var { monthlyInstalment, chipProps } = _a, other = __rest(_a, ["monthlyInstalment", "chipProps"]);
    const [_currentModal, setCurrentModal] = useModal();
    const { resourceStrings: { SPREADTHECOST, ANDTHEN, EQUALPAYMENTS, PAYMENTOPTIONFROM_MONTHLY, PAYMENTOPTION_MONTHLY, MONTHLYPAYMENTFEE, }, } = useGlobalContext();
    const { initialPaymentFormatted, subsequentPaymentFormatted, numberOfInstalments, initialPayment, subsequentPayment, } = monthlyInstalment;
    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setCurrentModal({
            isOpen: true,
            heading: PAYMENTOPTION_MONTHLY,
            body: `<p>
                        ${SPREADTHECOST}
                        <strong>${initialPayment && initialPaymentFormatted}</strong> ${ANDTHEN}
                        ${numberOfInstalments} ${EQUALPAYMENTS}
                        ${subsequentPayment && subsequentPaymentFormatted}
                    </p>
                    <p>${MONTHLYPAYMENTFEE}</p>`,
        });
    };
    return (React.createElement(Chip, Object.assign({ color: "neutral", icon: React.createElement(PiggyBankIcon, null), onClick: handleClick }, chipProps, other, { "data-id": "monthly-pill" }), `${PAYMENTOPTIONFROM_MONTHLY}\u00A0${subsequentPaymentFormatted}`));
}
